import styled from 'styled-components';

export const ReportCalculationWrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing.m} 0`};
`;
